// removed by extract-text-webpack-plugin
module.exports = {"CheckoutSummary":"CheckoutSummary__CheckoutSummary__-avOx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/CheckoutSummary/CheckoutSummary.css
// module id = 140
// module chunks = 0